module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("875aO"))).then(() => parcelRequire('1iHdE'));